module.exports = __webpack_public_path__ + "img/ring_y_e_1_1@3x.79e082e7.png";